'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signUp = exports.signIn = exports.resetPassword = undefined;

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

var resetPassword = exports.resetPassword = function resetPassword(_ref) {
  var _ref$email = _ref.email,
      email = _ref$email === undefined ? (0, _params.required)() : _ref$email;
  return (0, _client.get)('v1/account/' + email + '/requestpasswordreminder');
};

var signIn = exports.signIn = function signIn(_ref2) {
  var _ref2$email = _ref2.email,
      email = _ref2$email === undefined ? (0, _params.required)() : _ref2$email,
      _ref2$password = _ref2.password,
      password = _ref2$password === undefined ? (0, _params.required)() : _ref2$password;
  var _window = window,
      btoa = _window.btoa;

  var token = btoa(email + ':' + password);

  return (0, _client.get)('v1/account', {}, {}, {
    headers: {
      Authorization: 'Basic ' + token
    }
  }).then(function (data) {
    return {
      address: data.address,
      email: data.email,
      name: [data.firstName, data.lastName].join(' '),
      token: token,
      userId: data.userId
    };
  });
};

var signUp = exports.signUp = function signUp(_ref3) {
  var _ref3$firstName = _ref3.firstName,
      firstName = _ref3$firstName === undefined ? (0, _params.required)() : _ref3$firstName,
      _ref3$lastName = _ref3.lastName,
      lastName = _ref3$lastName === undefined ? (0, _params.required)() : _ref3$lastName,
      _ref3$email = _ref3.email,
      email = _ref3$email === undefined ? (0, _params.required)() : _ref3$email,
      _ref3$password = _ref3.password,
      password = _ref3$password === undefined ? (0, _params.required)() : _ref3$password,
      address = _ref3.address,
      title = _ref3.title,
      cause = _ref3.cause,
      reference = _ref3.reference;

  var payload = {
    acceptTermsAndConditions: true,
    firstName: firstName,
    lastName: lastName,
    email: email,
    password: password,
    title: title,
    address: address,
    reference: reference,
    causeId: cause
  };

  var request = address ? (0, _client.put)('v1/account', payload) : (0, _client.post)('v1/account/lite', payload);

  return request.then(function (data) {
    return {
      address: address,
      country: data.country,
      email: email,
      firstName: firstName,
      lastName: lastName,
      name: [firstName, lastName].join(' '),
      token: window.btoa(email + ':' + password)
    };
  });
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/authentication/justgiving/index.js
// module id = 1400
// module chunks = 0